import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import { connect } from 'react-redux';
import StudentsSearch from '../StudentsSearch';
import useDoImpersonate from 'legacy/src/components/impersonating/hooks/useDoImpersonate';
import {
  withUnitsConnectLean,
  getSectionAndStudentName,
} from 'legacy/src/components/impersonating/utils';
import ConfirmDialog from 'chameleon/ui-stack/ui/modals/confirm-dialog';
import './styles.scss';

const ImpersonateModal = (props) => {
  const {
    onClose,
    dispatch,
    router,
    userData,
    classes,
    resetUnitsInternalStore,
    impersonating,
  } = props;
  const [selectedStudent, setSelectedStudent] = useState(null);
  const chosenEducationPeriodCode = Number.parseInt(
    userData.chosenEducationPeriodCode,
    10,
  );
  const [currentClasses, setCurrentClasses] = useState([]);

  useEffect(() => {
    const filteredClasses = classes.filter(
      ({ educationPeriod }) => educationPeriod === chosenEducationPeriodCode,
    );
    setCurrentClasses(filteredClasses);
  }, [classes]);

  const [, doImpersonate] = useDoImpersonate({
    dispatch,
    router,
    userData,
    impersonating: { ...impersonating, teacherClasses: currentClasses },
    callback: () => {
      resetUnitsInternalStore();
    },
  });

  const onViewStudentExperience = () => {
    const { value, section } = selectedStudent;
    doImpersonate({
      studentId: value,
      sectionId: section.value,
      ...getSectionAndStudentName(value, section.value, currentClasses),
    });
  };

  const onStudentSelected = (section, student) => {
    const studentWithSection = {
      ...student,
      section,
    };
    setSelectedStudent(studentWithSection);
  };

  return (
    <ConfirmDialog
      size="small"
      title="Student View of AP Classroom"
      onClose={onClose}
      onSuccess={onViewStudentExperience}
      isPrimaryBtnDisabled={
        !selectedStudent || (selectedStudent && !selectedStudent.value)
      }
      content={{
        btnPrimary: 'View Student Experience',
      }}
    >
      <Fragment>
        <p>
          Select a student to view their AP Classroom experience. You will be
          able to see everything they see, but your activity will not be saved.
          When the student next logs in, their experience will be as they left
          it.
        </p>
        <div className="Impersonate--dropdowns">
          <p>Which student account would you like to view?</p>
          <StudentsSearch
            containerClassName="flex-column"
            classes={currentClasses}
            onStudentSelected={onStudentSelected}
          />
        </div>
      </Fragment>
    </ConfirmDialog>
  );
};

ImpersonateModal.propTypes = {
  onClose: PropTypes.func,
};

ImpersonateModal.defaultProps = {
  onClose: () => {},
};

const mapStateToProps = ({ userData, subject, impersonating }) => ({
  userData,
  classes: subject.data.classes || [],
  impersonating,
});
export default compose(
  withRouter,
  withUnitsConnectLean,
  connect(mapStateToProps),
)(ImpersonateModal);
